module.exports = __webpack_public_path__ + "static/media/ar.d3403ca0.svg";